import sox from './sox/all';
import scorecardFinance from './scorecard/scorecard-finance';
import scorecardProject from './scorecard/scorecard-projects';
import scorecardFinanceCharts from './scorecard/scorecard-finance-charts';
import scorecardProjectCharts from './scorecard/scorecard-projects-charts';
import projectOverview from './projectPage';
import userOverview from './user-overview';
import attachment_grid from './attachment-grid';
import accrual from './accrual/all';

export default function (nameController, nameAction, namePage) {
    // Sox
    if (nameAction === 'sox') sox();
    // Scorecards
    if (nameAction === 'financescorecard') scorecardFinance($('#scorecardFinance'));
    if (nameAction === 'projectscorecard') scorecardProject($('#scorecardProject'));
    if (window.location.pathname.includes('FinanceScorecard')) scorecardFinanceCharts();
    if (window.location.pathname.includes('ProjectScorecard')) scorecardProjectCharts();
    // Project Overview
    if (nameAction === 'projectoverview') projectOverview();
    if (nameAction === 'useroverview') userOverview();
    // attachment_grid($('.js-attachment-grid'));
    // Accruals
    if (nameController === 'finance') accrual();
}
